<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-3">Brannsikkerhet</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <BooleanInput v-if="!stepValues.advanced" v-model="stepValues.bool" @update-fields="updateFields"></BooleanInput>
      <BooleanInputTable 
        v-else 
        v-model="stepValues.bool" 
        objectTitle="Sjekkliste" 
        boolTitle="Svar" 
        commentTitle="Merknad" 
        @update-fields="updateFields"
      />
    </v-flex>
    <v-flex xs12 class="mt-2 mb-4" v-if="config.info">
      <h4 v-html="config.info" />
    </v-flex>
    <v-flex xs12 class="mb-3">
      <v-textarea
        box
        v-model="stepValues.comment"
        @input="updateFields"
        label="Kommentar"
      ></v-textarea>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
import BooleanInputTable from '../form/BooleanInputTable.vue';
export default {
  mixins: [step],
  components: { BooleanInputTable },
  mounted: function() {
    if(this.protocol.related_protocol) {
      if(this.protocol.related_protocol.steps.fire.saved_values.bool && !this.protocol.related_protocol.steps.fire.saved_values.loadedFromRelated) {
        this.protocol.related_protocol.steps.fire.saved_values.loadedFromRelated = true
        let bool = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.fire.saved_values.bool))
        for(let b in bool) {
          bool[b].relatedValue = bool[b].value
          bool[b].value = null
          bool[b].relatedComment = bool[b].comment
          bool[b].comment = null
        }
        this.stepValues.bool = bool
      }
    }
  },
  computed: {
    finished: function () {
      if(this.stepValues.advanced) {
        let allOk = true
        for(let b in this.stepValues.bool) {
          if((this.stepValues.bool[b].value !== 1 && this.stepValues.bool[b].value !== 0) && this.stepValues.bool[b].active) {
            allOk = false
          }
        }
        if(allOk) {
          return true
        }
        else {
          this.$emit("error", "Vennligst svar på alle punkter, eller deaktiver spørsmålet om det ikke er aktuelt.")
          return false
        }
      }
      return true
    }
  }
}
</script>
